export default __webpack_public_path__ + "static/media/astronaut.f43de94a.jpg";